<template>
  <div id="home">

    <div class="div">
      <div class="title">
        Edit Review Request
      </div>
      <div class="form">
        <div class="divt">
          Name*
          <el-input class="margin-top-switch name" placeholder="Please enter" v-model="ai_object.user_name"/>
        </div>

        <div class="divt">
          Assistants*
          <el-button class="margin-top-switch" style="width:100px;" size="mini" type="info" @click="select_show" round>Choice</el-button>
          <div class="margin-top-switch">
            <el-tag
              style="margin-left:10px;margin-top:10px;"
              v-for="(tag,index) in tags"
              :key="index"
              closable
              :type="tag.type"
              @close="closeTag(index)">
              {{tag.name}}
            </el-tag>
          </div>
        </div>

        <div class="divt">
          Comments
          <el-input class="margin-top-switch comments"
            placeholder="Please enter"
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 10}"
             v-model="ai_object.staff_comment"
            resize="none"/>
        </div>

        <div style="display: flex;align-items: center;justify-content: center;">
          <span class="btn" style="margin-right: 10px;" @click="save">Save</span>
        </div>
      </div>
    </div>
    <select-staffs ref="selectStaffsModel" @ok="selectedEmployee"></select-staffs>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,putActionApi } from '@/network/manageApi';
  import moment from 'moment/moment';
  import SelectStaffs from './aiBusiness/SelectStaffs'
  export default {
    name: 'EditAiBusinessPromoter',
    components: {
      SelectStaffs
    },
    data() {
      return {
        tags: [],
        ai_object: {user_name: "", staff_comment: ""}
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      this.uuid = this.$route.params.uuid
      if(this.uuid) {
        this.form_loading = true
        getActionApi('/review/business-promoter/ai-generate/details?review_generator_uuid=' + this.uuid).then(res => {
          this.ai_object.user_name = res.data.reviewer_name
          this.ai_object.staff_comment = res.data.staff_comments
          let array = []
          for(let item of res.data.employee_list) {
            let obj = {name: item.employee_name, staff_uuid: item.review_employee_uuid}
            array.push(obj)
          }
          this.tags = array
        })
      } else {
        this.$router.push({path:'/home'})
        return;
      }
    },
    methods:{
      select_show() {
        this.$refs.selectStaffsModel.init()
      },
      selectedEmployee(list) {
        const map = this.tags.reduce((acc, item) => {
          acc[item.staff_uuid] = item;
          return acc;
        }, {});
        for(let item of list) {
          if(!map[item.review_employee_uuid]) {
            let obj = {name: item.employee_name, staff_uuid: item.review_employee_uuid}
            this.tags.push(obj);
          }
        }
      },
      closeTag(index) {
        this.tags.splice(index, 1);
      },
      moment,
      save() {
        if(!this.ai_object.user_name) {
          this.$message({
            message: 'Please enter name.',
            type: 'warning'
          });
          return;
        }
        if(this.tags.length == 0) {
          this.$message({
            message: 'Please add an assistant.',
            type: 'warning'
          });
          return;
        }
        if(!this.ai_object.staff_comment) {
          this.$message({
            message: 'Please fill in the comments.',
            type: 'warning'
          });
          return;
        }
        const staff_list = this.tags.map(item => item.staff_uuid);
        this.ai_object.staff_uuid_list = staff_list
        this.ai_object.review_generator_uuid = this.uuid
        this.form_loading = true
        putActionApi("/review/business-promoter/ai-generate/edit", this.ai_object).then((res) => {
          if(res.code == 201 || res.code == 200) {
            this.$message.success({message: "Edit Success"});
            this.$router.push({path:'/aiBusinessPromoter/detail/' + this.uuid})
          }
        }).catch((err) => {
          this.$message.error({message: err.response.data.details.data.message});
        }).finally((res) => {
          this.form_loading = false
        })
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .div{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
  .label{display: flex;align-items: center;justify-content: center;}
  .label .no{background-color: #FED7D7;color: #822727;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .label .yes{background-color: #b3edff;color: #0075cb;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .pager{display: flex;justify-content: center;}
  .btn{height:40px;width:86px;cursor: pointer;background-color: #5856D6;color:#ffffff;border-radius: 6px;font-size: 14px;display: flex;align-items: center;justify-content: center;}
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .divt{display: flex;flex-direction: column;color:#2D3748;font-weight: bold;padding-bottom:20px;}
  .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .margin-top-switch {margin-top: 10px;width: 500px;}

  .comments {width: 50%;}
  @media (max-width: 768px) {
    .title{flex-direction: column;}
    .div{padding:20px 5px;}
    .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
    .margin-top-switch {margin-top: 10px;width: 90%;}
    .comments {width: 98%;}
    .name {width: 98%;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
  .font-size-16 {font-size: 20px;}



</style>
